import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=b66d1784&"
import script from "./Public.vue?vue&type=script&lang=js&"
export * from "./Public.vue?vue&type=script&lang=js&"
import style0 from "./Public.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VLayout})
